import { render, staticRenderFns } from "./ConsignmentDetails.vue?vue&type=template&id=7516dfba&scoped=true"
import script from "./ConsignmentDetails.vue?vue&type=script&lang=js"
export * from "./ConsignmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsignmentDetails.vue?vue&type=style&index=0&id=7516dfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516dfba",
  null
  
)

export default component.exports